export default __webpack_public_path__ + "static/media/Visual-Studio-Code-Logo.f57bbf46.svg";